import { render, staticRenderFns } from "./PasswordUpdateConfirm.vue?vue&type=template&id=a7ef0818&"
import script from "./PasswordUpdateConfirm.vue?vue&type=script&lang=ts&"
export * from "./PasswordUpdateConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports